import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/sections/Hero";
import NaicsCodes from "@/components/sections/NaicsCodes";
import About from "@/components/sections/About";
import Capabilities from "@/components/sections/Capabilities";
import WhoWeServe from "@/components/sections/WhoWeServe";
import WhyUs from "@/components/sections/WhyUs";
import OperatingModel from "@/components/sections/OperatingModel";
import Teaming from "@/components/sections/Teaming";
import PastPerformance from "@/components/sections/PastPerformance";
import Certifications from "@/components/sections/Certifications";
import Contact from "@/components/sections/Contact";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <NaicsCodes />
        <About />
        <Capabilities />
        <WhoWeServe />
        <WhyUs />
        <OperatingModel />
        <Teaming />
        <PastPerformance />
        <Certifications />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: '#141414',
            border: '1px solid #2A2A2A',
            color: '#fff',
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
